import { render, staticRenderFns } from "./icon-alert.vue?vue&type=template&id=3502bdda&"
import script from "./icon-alert.vue?vue&type=script&lang=js&"
export * from "./icon-alert.vue?vue&type=script&lang=js&"
import style0 from "./icon-alert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports